import React, { useEffect, useState } from 'react'

import './styles.sass'

interface FadeProps {
	show: boolean
	children: React.ReactNode
	duration?: number
}

const Fade: React.FC<FadeProps> = ({ show, children, duration = 200 }) => {
	const [render, setRender] = useState<boolean>(show)

	useEffect(() => {
		setRender(show)
	}, [show])

	const onAnimationEnd = () => {
		if (!show) setRender(false)
	}

	return render ? (
		<div
			style={{
				animation: `${show ? 'fadeIn' : 'fadeOut'} ${duration}ms ease-in`,
			}}
			onAnimationEnd={onAnimationEnd}>
			{children}
		</div>
	) : null
}

export default Fade
